import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_FHIRResource } from '../../../../../_entity.js';
import './Renderer_FHIRResourceHeader.scss';
export class Renderer_FHIRResourceHeader extends ComponentSync {
    __onFHIRResourcesUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.resource?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ resource: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.resource?._id)
            state.resource = ModuleFE_FHIRResource.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'fhir-resource-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        return _jsx("div", { className: 'fhir-resource-header__title', children: this.state.resource?.label ?? 'N/A' });
    };
    render_Subtitle = () => {
        const resource = this.state.resource;
        if (!resource?.urlPrefix)
            return;
        return _jsx("span", { className: 'fhir-resource-header__sub-title', children: resource.urlPrefix });
    };
}
//# sourceMappingURL=Renderer_FHIRResourceHeader.js.map